const STORAGE_KEY = 'rh_purchased_upsells_v2';
const TTL_MS = 24 * 60 * 60 * 1000;
function readMap() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return {};
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed))
            return {};
        return parsed;
    }
    catch {
        return {};
    }
}
function pruneMap(map) {
    const now = Date.now();
    const pruned = {};
    for (const [uuid, entries] of Object.entries(map)) {
        if (!Array.isArray(entries))
            continue;
        const valid = entries.filter((entry) => now - entry.timestamp < TTL_MS);
        if (valid.length > 0)
            pruned[uuid] = valid;
    }
    return pruned;
}
function getPurchasedOrderIds(uuid) {
    if (!uuid)
        return [];
    const entries = pruneMap(readMap())[uuid] || [];
    return entries.map((entry) => entry.orderId);
}
function savePurchasedOrderIds(uuid, orderIds) {
    if (!uuid)
        return;
    try {
        const map = pruneMap(readMap());
        const existing = map[uuid] || [];
        const existingIds = new Set(existing.map((e) => e.orderId));
        const now = Date.now();
        const newEntries = orderIds.filter((id) => !existingIds.has(id)).map((id) => ({ orderId: id, timestamp: now }));
        map[uuid] = [...existing, ...newEntries];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    }
    catch {
        // fail-open
    }
}
export { STORAGE_KEY, TTL_MS, getPurchasedOrderIds, savePurchasedOrderIds };
